import React from 'react';
import { Circle, CircleMarker, MapContainer, TileLayer, Tooltip } from 'react-leaflet';
import type { ChefResult } from '../../utils/search';
import { cn } from '../../utils/cn';
export function ResultsMap({
  results,
  origin,
  hoveredId,
  onHover,
  className
}: {
  results: ChefResult[];
  origin: {
    lat: number;
    lng: number;
  };
  hoveredId?: string;
  onHover: (id?: string) => void;
  className?: string;
}) {
  return <div className={cn('overflow-hidden rounded-xl border border-hairline', className)} data-id="element-479" data-mp="21ux7qpa3womq">
      <MapContainer center={[origin.lat, origin.lng]} zoom={11} scrollWheelZoom={false} style={{
      height: '100%',
      width: '100%'
    }} aria-label="Map of chefs and their service areas" data-id="element-480" data-mp="25upk7d2mfexd">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>' data-id="element-481" data-mp="1wxf85phzblre" />

        <CircleMarker center={[origin.lat, origin.lng]} radius={7} pathOptions={{
        color: '#22271F',
        fillColor: '#22271F',
        fillOpacity: 1,
        weight: 2
      }} data-id="element-482" data-mp="10gdzw2t4tiau">
          <Tooltip data-id="element-483" data-mp="1aetr05s5srkc">You</Tooltip>
        </CircleMarker>

        {results.map(({
        chef,
        price,
        distance
      }) => {
        const active = hoveredId === chef.id;
        return <React.Fragment key={chef.id} data-id="element-484" data-mp="1jdyod8rzieux">
              {active && <Circle center={[chef.lat, chef.lng]} radius={4200} pathOptions={{
            color: '#B24720',
            fillColor: '#B24720',
            fillOpacity: 0.09,
            weight: 1
          }} data-id="element-485" data-mp="1jc46k3c0f2v2" />}
              <CircleMarker center={[chef.lat, chef.lng]} radius={active ? 13 : 9} eventHandlers={{
            mouseover: () => onHover(chef.id),
            mouseout: () => onHover(undefined)
          }} pathOptions={{
            color: '#FDF8F0',
            weight: 2,
            fillColor: active ? '#B24720' : '#3A4A33',
            fillOpacity: 1
          }} data-id="element-486" data-mp="1o68byi5mn2u1">
                <Tooltip direction="top" offset={[0, -8]} data-id="element-487" data-mp="2f3plniw2z62f">
                  <span className="font-semibold" data-id="element-488" data-mp="2jvh4165325hh">{chef.name}</span>
                  <br data-id="element-489" data-mp="2jws5gzb2315f" />฿{price.toLocaleString('en-US')} / guest · {distance} km
                </Tooltip>
              </CircleMarker>
            </React.Fragment>;
      })}
      </MapContainer>
    </div>;
}